'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlMainContainer", function () {
  var breadCrumbClass = "tl-breadcrumb-page";
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs, ctrl) {},
    controller: function controller($scope, $element) {
      var ctrl = this;
      ctrl.setBreadcrumbLayout = function (flag) {
        flag ? $element.addClass(breadCrumbClass) : $element.removeClass(breadCrumbClass);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/mainContainer.js
// module id = 3003
// module chunks = 13